export interface GeneralFieldConfig {
  name: string;
  labelKey: string;
}

export const DAM_HYDROLOGY_FIELDS: GeneralFieldConfig[] = [
  {
    name: "maximumMaximorumLevel",
    labelKey: "admin.structures.hydrology.label.maximumMaximorumLevel",
  },
  {
    name: "criticalDuration",
    labelKey: "admin.structures.hydrology.label.criticalDuration",
  },
  {
    name: "inflowRate",
    labelKey: "admin.structures.hydrology.label.inflowRate",
  },
  {
    name: "outflowRate",
    labelKey: "admin.structures.hydrology.label.outflowRate",
  },
  {
    name: "designRainfall",
    labelKey: "admin.structures.hydrology.label.designRainfall",
  },
  {
    name: "contributingBasinArea",
    labelKey: "admin.structures.hydrology.label.contributingBasinArea",
  },
  {
    name: "returnPeriod",
    labelKey: "admin.structures.hydrology.label.returnPeriod",
  },
  {
    name: "totalVolumeAtCrestElevation",
    labelKey: "admin.structures.hydrology.label.totalVolumeAtCrestElevation",
  },
  {
    name: "spillwayType",
    labelKey: "admin.structures.hydrology.label.spillwayType",
  },
  {
    name: "spillwaySill",
    labelKey: "admin.structures.hydrology.label.spillwaySill",
  },
  {
    name: "referenceDocument",
    labelKey: "admin.structures.hydrology.label.referenceDocument",
  },
];

export const DAM_GEOMETRY_FIELDS_SUBSET: GeneralFieldConfig[] = [
  { name: "crestElevation", labelKey: "admin.structures.geometry.label.crestElevation" },
  { name: "damHeight", labelKey: "admin.structures.geometry.label.damHeight" },
  { name: "crestLength", labelKey: "admin.structures.geometry.label.crestLength" },
  { name: "crestWidth", labelKey: "admin.structures.geometry.label.crestWidth" },
  {
    name: "upstreamSlopeInclination",
    labelKey: "admin.structures.geometry.label.upstreamSlopeInclination",
  },
];

export const ALL_DAM_GEOMETRY_FIELDS: GeneralFieldConfig[] = [
  { name: "crestElevation", labelKey: "admin.structures.geometry.label.crestElevation" },
  { name: "damHeight", labelKey: "admin.structures.geometry.label.damHeight" },
  { name: "crestLength", labelKey: "admin.structures.geometry.label.crestLength" },
  { name: "crestWidth", labelKey: "admin.structures.geometry.label.crestWidth" },
  { name: "typicalBermWidth", labelKey: "admin.structures.geometry.label.typicalBermWidth" },
  {
    name: "upstreamSlopeInclination",
    labelKey: "admin.structures.geometry.label.upstreamSlopeInclination",
  },
  {
    name: "downstreamSlopeInclination",
    labelKey: "admin.structures.geometry.label.downstreamSlopeInclination",
  },
  {
    name: "betweenBermsSlopeInclination",
    labelKey: "admin.structures.geometry.label.betweenBermsSlopeInclination",
  },
  {
    name: "globalDownstreamSlopeInclination",
    labelKey: "admin.structures.geometry.label.globalDownstreamSlopeInclination",
  },
  { name: "referenceDocument", labelKey: "admin.structures.geometry.label.referenceDocument" },
];

export const RISK_MAPPING_FIELDS: GeneralFieldConfig[] = [
  { name: "wasteType", labelKey: "admin.structures.riskMapping.label.wasteType" },
  {
    name: "downstreamHumanOccupation",
    labelKey: "admin.structures.riskMapping.label.downstreamHumanOccupation",
  },
  {
    name: "downstreamEnvironmentalInterest",
    labelKey: "admin.structures.riskMapping.label.downstreamEnvironmentalInterest",
  },
  {
    name: "downstreamInstallation",
    labelKey: "admin.structures.riskMapping.label.downstreamInstallation",
  },
];

export const RAISING_HISTORY_COLUMNS = [
  { key: "executiveProjectDesigner", labelKey: "admin.structures.raisingHistory.label.executiveProjectDesigner" },
  { key: "stage", labelKey: "admin.structures.raisingHistory.label.stage" },
  { key: "method", labelKey: "admin.structures.raisingHistory.label.method" },
  { key: "elevation", labelKey: "admin.structures.raisingHistory.label.elevation" },
  { key: "occurredOn", labelKey: "admin.structures.raisingHistory.label.occurredOn" },
];

export const RESERVOIR_COLUMNS = [
  { key: "recordedOn", labelKey: "admin.structures.reservoirManagement.label.recordedOn" },
  { key: "occupiedArea", labelKey: "admin.structures.reservoirManagement.label.occupiedArea" },
  { key: "totalVolume", labelKey: "admin.structures.reservoirManagement.label.totalVolume" },
  { key: "totalOccupiedVolume", labelKey: "admin.structures.reservoirManagement.label.totalOccupiedVolume" },
  { key: "availableVolume", labelKey: "admin.structures.reservoirManagement.label.availableVolume" },
  { key: "rejectOccupiedVolume", labelKey: "admin.structures.reservoirManagement.label.rejectOccupiedVolume" },
  { key: "waterOccupiedVolume", labelKey: "admin.structures.reservoirManagement.label.waterOccupiedVolume" },
  { key: "waterLevel", labelKey: "admin.structures.reservoirManagement.label.waterLevel" },
];
